<div class="title-row">
  <h1>{{ 'DEAD_LETTERS.TITLE' | translate }}</h1>
</div>
<div class="dead-letters">
  <app-dead-letter-filters
    [filters]="filters"
    (filtersChange)="onFiltersChange($event)">
  </app-dead-letter-filters>

  <app-dead-letter-bulk-actions
    [selectedCount]="selectedCount"
    [totalCount]="totalCount"
    [selectAll]="selectAll"
    [actionInProgress]="bulkActionInProgress"
    (bulkActionClick)="onBulkAction($event)">
  </app-dead-letter-bulk-actions>

  <app-dead-letter-list
    [items]="items"
    [selectedIds]="selectedIds"
    [selectAll]="selectAll"
    [initialLoading]="initialLoading"
    [appendLoading]="appendLoading"
    [actionInProgressIds]="actionInProgressIds"
    [initialError]="initialError ? ('DEAD_LETTERS.ERRORS.INITIAL_LOAD_FAILED' | translate) : null"
    [hasActiveFilters]="filters.searchTerm !== '' || filters.eventType !== '' || filters.dateFrom !== null || filters.dateTo !== null"
    (loadMore)="onLoadMore()"
    (selectionChange)="onSelectionChange($event)"
    (selectAllChange)="onSelectAllChange($event)"
    (idClick)="onIdClick($event)"
    (removeClick)="onRemoveClick($event)"
    (replayClick)="onReplayClick($event)"
    (retryFirstPage)="loadFirstPage()">
  </app-dead-letter-list>
</div>
